import {Directive, forwardRef, Injectable} from "@angular/core";
import {AbstractControl, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {IIdentifier, ResponseCheckCodeWithBirthday, ResponseCheckCodeWithoutBirthday} from "build/project/openapi-cast/project/project-openapi-cast.model";
import {ProjectOpenapiCastService} from "build/project/openapi-cast/project/project-openapi-cast.service";
import {of} from "rxjs";
import {first, map} from "rxjs/operators";
import {ValidationbirthdayService} from "src/app/shared/services/validationbirthday/validationbirthday.service";

@Injectable({
   providedIn: "root"
})

export class CodeValidationService implements Validator {

   private errorC: ValidationErrors | undefined;
   private identifier: IIdentifier | undefined;

   constructor (private sProjectOpenapi: ProjectOpenapiCastService, public sValidationBirthday: ValidationbirthdayService) {}

   public validatorFunction: AsyncValidatorFn = (control) => control?.value !== "" && this.checkToggleValid(control)
      ? !this.sValidationBirthday.birthday
         ?  this.sProjectOpenapi.checkCodeWithoutBirthday({code: control.value})
            .pipe(
               map(value => this.isCodeValid({code: value.code!}, control.value)),
               first()
            )
         : this.checkIdentifier(control)
            ? this.sProjectOpenapi.checkCodeWithBirthday(<IIdentifier>this.identifier)
               .pipe(
                  map(value => this.isCodeBirthdayValid({code: value.code!}, <IIdentifier>this.identifier, control)),
                  first()
               )
            : of(<ValidationErrors>this.errorC)
      : of(null);
  
   validate (control: AbstractControl) {
      return this.validatorFunction(control);
   }

   private checkIdentifier (control: AbstractControl): boolean {
      const uuid: string = control.value;
      const birthday: string = this.sValidationBirthday.isModule ? "01.01.1900" : control.parent?.get('formControlBirthday')?.value ? control.parent?.get('formControlBirthday')?.value.format("DD.MM.yyyy") : control.parent?.get('formControlBirthday')?.value;

      if (!uuid || uuid == '') {
         this.errorC = {uuidIsEmpty: true};
         return false;
      }

      if ((!birthday || birthday == '')) {
         this.errorC = {birthdayIsEmpty: true};
         return false;
      }

      this.identifier = {
         code: uuid,
         birthday: birthday
      };

      return true;
   }

   private isCodeBirthdayValid (value: ResponseCheckCodeWithBirthday, identifier: IIdentifier, control: AbstractControl): ValidationErrors | null {
      if (value && value.code && value.code == identifier.code) {
         control.parent?.get('formControlBirthday')?.setErrors(null);
         return null;
      } else if (!this.sValidationBirthday.isModule) {
         control.parent?.get('formControlBirthday')?.setErrors({birthdayNotExists: true}) ;
         return {birthdayNotExists: true};
      } else {
         control.parent?.get('formControlUuid')?.setErrors({codeNotExists: true});
         return this.sValidationBirthday.isModule ? {consultant: true} : {codeNotExists: true};
      }
   }

   private isCodeValid (value: ResponseCheckCodeWithoutBirthday, code: string): ValidationErrors | null {
      const valid: boolean = value && value.code && value.code == code ? true : false;
      return valid ? null : this.sValidationBirthday.isModule ? {consultant: true} : {codeNotExists: true};
   }

   private checkToggleValid (control: AbstractControl): boolean {
      control.parent?.get('toggle')?.updateValueAndValidity({emitEvent: false, onlySelf: true});
      return control.parent?.get('toggle')?.valid ? control.parent?.get('toggle')?.dirty ? true : false : false;
   }
}

@Directive({
   selector: '[UuidIsValid][formControlName]',
   providers: [
      {
         provide: NG_ASYNC_VALIDATORS,
         useExisting: forwardRef(() => CodeValidationService),
         multi: true
      }
   ],
   standalone: false
})
  
export class CheckUuidValidationDirective {}